module.exports = __webpack_public_path__ + "static/media/trialPeriod.cabdb811.svg";